// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import stat from '@infrastructure/shared/constant'
// ** Axios Imports
import axios from 'axios'

export const getGrade = createAsyncThunk('appNilaiApV2/getGrade', async params => {
  const response = await axios.get(stat.URL_GRADE_KINDERGATEN, { params })
  return {
    data: response.data
  }
})

export const getGradeKelas = createAsyncThunk('appNilaiApV2/getGradeKelas', async (kode_grade, {params, getState })  => {
  const response = await axios.get(stat.URL_KELAS + kode_grade, { params })
  console.log('current state:', getState())
  return response.data
})

export const getAspekPerkembangan = createAsyncThunk('appNilaiApV2/getAspekPerkembangan', async (kode_grade, {params, getState })  => {
  const response = await axios.get(stat.URL_ASPEK_PERKEMBANGAN_V2 + kode_grade, { params })
  console.log('current state:', getState())
  return response.data
})

export const getAspekPerkembanganMember = createAsyncThunk('appNilaiApV2/getAspekPerkembanganMember', async (id_kelas, {params, getState, rejectWithValue })  => {
  try {
    const add_url = "member/"
    console.log('V2 - Request URL:', stat.URL_ASPEK_PERKEMBANGAN_V2 + add_url + id_kelas)
    const response = await axios.get(stat.URL_ASPEK_PERKEMBANGAN_V2 + add_url + id_kelas, { params })
    console.log('V2 - Response:', response.data)
    console.log('current state:', getState())
    // Backend returns { code, data, message }, so we need to return response.data.data
    return response.data?.data || response.data || []
  } catch (error) {
    console.error('V2 - Error in getAspekPerkembanganMember:', error)
    console.error('V2 - Error response:', error.response?.data)
    return rejectWithValue(error.response?.data || error.message)
  }
})

// ASPEK PERKEMBANGAN ANAK V2

export const putAspekPerkembanganNilai = createAsyncThunk('appNilaiApV2/putAspekPerkembanganNilai', async (request, { dispatch, getState }) => {
  const add_url = "member/nilai"
  const response = await axios.put(stat.URL_ASPEK_PERKEMBANGAN_V2 + add_url, request.payload)
  await dispatch(getAspekPerkembanganMember(getState().nilaiapv2.idKelas))
  return response.data
})

export const putAspekPerkembanganKesehatan = createAsyncThunk('appNilaiApV2/putAspekPerkembanganKesehatan', async (request, { dispatch, getState }) => {
  const add_url = "member/kesehatan"
  const response = await axios.put(stat.URL_ASPEK_PERKEMBANGAN_V2 + add_url, request.payload)
  await dispatch(getAspekPerkembanganMember(getState().nilaiapv2.idKelas))
  return response.data
})

export const appNilaiApV2Slice = createSlice({
  name: 'appNilaiApV2',
  initialState: {
    grade: [],
    statusLoadGrade: null,
    kelas: [],
    idKelas: null,
    statusIdKelas: null,
    kodeGrade: null,
    siswa_nilai: null,
    statusAspekPerkembangan: null,
    responseAspekPerkembangan: null, 
    statusAspekPerkembanganMember: null,
    reseponsePerkembanganAnakNilai: null,

    statusPutAspekPerkembanganNilai: null, 

    statusPutAspekPerkembanganKesehatan: null, 
    params: {
      filter: '',
      q: '',
      sort: '',
      tag: ''
    }
  },
  reducers: {
    selectIdKelas: (state, action) => {
      state.idKelas = action.payload
    },
    selectKodeGrade: (state, action) => {
      state.kodeGrade = action.payload
    },
    selectSiswa: (state, action) => {
      state.siswa_nilai = action.payload
    },
    stateReset: (state) => {
      state.statusAspekPerkembangan = null
      state.statusAspekPerkembanganMember = null
      state.statusPutAspekPerkembanganNilai = null
      state.statusPutAspekPerkembanganKesehatan = 'loading'
    }
  },
  extraReducers: builder => {
    
    builder.addCase(getGrade.fulfilled, (state, action) => {
      state.grade = action.payload.data
      state.params = action.payload.params
    })

    builder.addCase(getGradeKelas.pending, (state) => {
      state.statusIdKelas = 'loading'
    })
    builder.addCase(getGradeKelas.fulfilled, (state, action) => {
      console.log("loaded", action.payload.data)
      console.log("Full filled Kelas", action.payload.data)
      state.statusIdKelas = 'loaded'
      state.kelas = action.payload.data
      state.params = action.payload.params
    })
  

    builder.addCase(putAspekPerkembanganNilai.pending, (state) => {
      state.statusPutAspekPerkembanganNilai = 'loading'
    })
    builder.addCase(putAspekPerkembanganNilai.fulfilled, (state) => {
      state.statusPutAspekPerkembanganNilai = 'loaded'
    })
    builder.addCase(putAspekPerkembanganNilai.rejected, (state, action) => {
      state.statusPutAspekPerkembanganNilai = 'failed'
      state.reseponsePerkembanganAnakNilai = action.error
    })

    builder.addCase(putAspekPerkembanganKesehatan.pending, (state) => {
      state.statusPutAspekPerkembanganKesehatan = 'loading'
    })
    builder.addCase(putAspekPerkembanganKesehatan.fulfilled, (state) => {
      state.statusPutAspekPerkembanganKesehatan = 'loaded'
    })
    builder.addCase(putAspekPerkembanganKesehatan.rejected, (state, action) => {
      state.statusPutAspekPerkembanganKesehatan = 'failed'
      state.reseponsePerkembanganAnakNilai = action.error
    })
     // Get Aspek Perkembangan
    // ==========================================================

    builder.addCase(getAspekPerkembangan.pending, (state) => {
      state.statusAspekPerkembangan = 'loading'
    })
    builder.addCase(getAspekPerkembangan.fulfilled, (state, action) => {
      console.log("loaded", action.payload.data)
      state.statusAspekPerkembangan = 'loaded'
      state.responseAspekPerkembangan = action.payload.data
    })
    builder.addCase(getAspekPerkembangan.rejected, (state, action) => {
      state.statusAspekPerkembangan = 'failed'
      state.responseAspekPerkembangan = action.error
    })

  
    // Get Member
    // ==========================================================

    builder.addCase(getAspekPerkembanganMember.pending, (state) => {
      state.statusAspekPerkembanganMember = 'loading'
    })
    builder.addCase(getAspekPerkembanganMember.fulfilled, (state, action) => {
      console.log("V2 - loaded aspek perkembangan member", action.payload)
      state.statusAspekPerkembanganMember = 'loaded'
      // Handle both response formats: { data: [...] } or directly [...]
      state.reseponsePerkembanganAnakNilai = action.payload?.data || action.payload || []
    })
    builder.addCase(getAspekPerkembanganMember.rejected, (state, action) => {
      state.statusAspekPerkembanganMember = 'failed'
      state.reseponsePerkembanganAnakNilai = action.error
    })
   
    
  }
})

export const { selectIdKelas, selectKodeGrade, selectSiswa, stateReset } = appNilaiApV2Slice.actions

export default appNilaiApV2Slice.reducer
